var React = require('react');

function Replace (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#53647f;}.cls-2{fill:none;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"replace-24px"},[React.createElement("polygon",{"className":"cls-1","points":"8 4 4 9 7 9 7 18 9 18 9 9 12 9 8 4","key":0}),React.createElement("polygon",{"className":"cls-1","points":"17 15 17 6 15 6 15 15 12 15 16 20 20 15 17 15","key":1}),React.createElement("rect",{"id":"_24x24","data-name":"24x24","className":"cls-2","width":"24","height":"24","key":2})]))]);
}

Replace.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Replace;

Replace.default = Replace;
